'use strict';
angular.module('weiboContentModule', []).directive('weiboContent', ['$timeout',
    function($timeout) {
        return {
            scope: true,
            restrict: 'E',
            templateUrl: './editingCenter/weibo/directive/weiboContent/index.html',
            replace: true,
            link: function($scope) {

                /**
                 * [addEmoji description] 添加表情
                 *
                 * @param   {[type]}  item  [item description] 表情
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.addEmoji = function(item) {
                    var $t = $scope.element.find('.weibo_editor textarea')[0];
                    var startPos = $t.selectionStart;
                    var endPos = $t.selectionEnd;
                    $scope.list.TEXT = $scope.list.TEXT.substring(0, startPos) + item.value + $scope.list.TEXT.substring(endPos, $scope.list.TEXT.length);
                    $timeout(function() {
                        $t.selectionStart = $t.selectionEnd = startPos + item.value.length;
                        $t.focus();
                    });
                };

                /**
                 * [addTopic description] 添加话题
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.addTopic = function() {
                    var $t = $scope.element.find('.weibo_editor textarea')[0];
                    var startPos = $t.selectionStart;
                    var endPos = $t.selectionEnd;
                    $scope.list.TEXT = $scope.list.TEXT.substring(0, startPos) + '##' + $scope.list.TEXT.substring(endPos, $scope.list.TEXT.length);
                    $timeout(function() {
                        $t.selectionStart = $t.selectionEnd = startPos + 1;
                        $t.focus();
                    });
                };
            }
        };
    }
]);
